import React from "react";

const LoadingComponent = ({ text }) => {
  return (
    <div className="w-full h-screen h-screen-ios bg-gradient-to-r  -mt-12  from-headerPrimary to-headerSecondary flex justify-center items-center ">
      <div className="flex text-textPrimary animate-bounce">
        {text ? text : "here"}
      </div>
    </div>
  );
};

export default LoadingComponent;
